import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
//import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React, { Fragment } from 'react';
import styled, { css } from 'react-emotion';
import {
  ProductSection as UIProductSection,
  SectionHeading
} from './ProductInfo';

import { ReactComponent as ArrowSVG } from '../../svg/Arrow.svg';

const Description = styled('article')`
  line-height: 25px;
`;

const ProductSection = styled(UIProductSection)`
  padding: 1.125rem ${({ theme }) => theme.sizes[1]};
  margin-bottom: 0.75rem;
  background: ${({ theme }) => theme.colors.themeGrey};
  font-size: 1.125rem;
  ${SectionHeading} {
    display: flex;
    justify-items: space-between;
    align-items: center;
    margin-bottom: 0;
    + * > :first-child {
      margin-top: 1rem;
    }
  }
`;

const IndicatorIcon = styled(ArrowSVG)`
  margin-left: auto;
  font-size: 1.25rem;
  transition: transform ease-in-out 0.2s;
  ${props =>
    props.toggle.toggle === true &&
    css`
      transform: rotate(180deg);
    `}
`;

const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon toggle={{ toggle: isOpen }} />
);

const ProductInfoAccordion = ({ product }) => {
  const tabs = product.customFields.filter(tab =>
    tab.key.includes('tab-') ? tab : null
  );

  return (
    <Accordion single>
      {({ openIndexes, handleClick, AccordionContent }) => (
        <Fragment>
          <ProductSection hideArrow>
            <SectionHeading onClick={() => handleClick(0)}>
              <span>{t('Product description')}</span>
              <AccordionIndicator isOpen={openIndexes.includes(0)} />
            </SectionHeading>
            <AccordionContent isOpen={openIndexes.includes(0) || 'opened'}>
              <Description
                dangerouslySetInnerHTML={{
                  __html: product.description
                }}
              />
            </AccordionContent>
          </ProductSection>
          {tabs &&
            tabs.map((tab, i) => {
              return (
                <ProductSection key={i}>
                  <SectionHeading onClick={() => handleClick(i + 1)}>
                    <span>{tab.title}</span>
                    <AccordionIndicator isOpen={openIndexes.includes(i + 1)} />
                  </SectionHeading>
                  <AccordionContent isOpen={openIndexes.includes(i + 1)}>
                    <p dangerouslySetInnerHTML={{ __html: tab.stringValue }} />
                    {/*<ProductSpecifications fields={product.customFields} />*/}
                  </AccordionContent>
                </ProductSection>
              );
            })}
        </Fragment>
      )}
    </Accordion>
  );
};

export default ProductInfoAccordion;
